<template>
	<el-card class="menuBody" style="width: 100%;" shadow="never">
		<left-floor-tree @chooseNode="selectNode"></left-floor-tree>
		<el-card class="box-card">
			<div class="search-title">
				智能表使用量
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.actualNo" placeholder="请输入实际表号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-input size="small" v-model="query.roomName" placeholder="请输入房间号" clearable></el-input>
			</div>
			<div class="search-input-item">
				<el-select size="small" v-model="query.meterType" placeholder="仪表类型" clearable>
					<el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="search-input-item">
				<el-date-picker
					ref="dateTimePicker"
					v-model="query.dataRange"
					type="daterange"
					align="right"
					size="small"
					style="width: 410px"
					value-format="yyyy-MM-dd"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
				>
				</el-date-picker>
			</div>

			<div class="search-button-tools">
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.meterUse.listPage'" :loading="tableLoading" @click="doSearch">查询</el-button>
				<el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.meterUse.export'" v-debounce @click="doExport">导出</el-button>
			</div>

			<el-table :data="overviewData" row-key="status" v-loading="loadingOverviewData" style="margin: 20px 0px" border>
				<el-table-column prop="title" label="合计"></el-table-column>
				<el-table-column prop="min" :label="'期初累计(' + monthStart + ')'"></el-table-column>
				<el-table-column prop="max" :label="'期末累计(' + monthEnd + ')'"></el-table-column>
				<el-table-column prop="diff" label="当期累计"></el-table-column>
			</el-table>

			<el-table :data="tableData" row-key="id" border :stripe="true" v-loading="tableLoading" tooltip-effect="light">
				<el-table-column width="250" show-overflow-tooltip prop="payMeterNo" label="表号" fixed="left"></el-table-column>
				<el-table-column width="100" show-overflow-tooltip prop="meterType" label="类型"></el-table-column>
				<el-table-column width="200" show-overflow-tooltip prop="projectName" label="项目小区"></el-table-column>
				<el-table-column width="150" show-overflow-tooltip prop="floorName" label="楼栋"></el-table-column>
				<el-table-column width="100" show-overflow-tooltip prop="roomName" label="房间号"></el-table-column>
				<el-table-column width="100" show-overflow-tooltip prop="roomCusName" label="业主名"></el-table-column>
				<el-table-column :label="'期初(' + monthStart + ')'" align="center">
					<el-table-column label="累计使用" align="center">
						<el-table-column width="120" show-overflow-tooltip prop="minTotalUse" label="用量(度/吨)"></el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="minTotalAmount" label="金额(元)"></el-table-column>
					</el-table-column>
					<el-table-column width="120" show-overflow-tooltip prop="minPayAmount" label="累计充值(元)"></el-table-column>
					<el-table-column width="100" show-overflow-tooltip prop="minRemainAmount" label="剩余(元)">
						<template slot-scope="scope">
							<span :class="isAddRed(scope.row.minRemainAmount)">{{ scope.row.minRemainAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column width="120" show-overflow-tooltip prop="minRemainUse" label="剩余(度/吨)">
						<template slot-scope="scope">
							<span :class="isAddRed(scope.row.minRemainUse)">{{ scope.row.minRemainUse }}</span>
						</template>
					</el-table-column>
					<el-table-column width="180" prop="minDate" label="采集时间"></el-table-column>
				</el-table-column>
				<el-table-column :label="'期末(' + monthEnd + ')'" align="center">
					<el-table-column label="累计使用" align="center">
						<el-table-column width="120" show-overflow-tooltip prop="maxTotalUse" label="用量(度/吨)"></el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="maxTotalAmount" label="金额(元)"></el-table-column>
					</el-table-column>
					<el-table-column width="120" show-overflow-tooltip prop="maxPayAmount" label="累计充值(元)"></el-table-column>
					<el-table-column width="100" show-overflow-tooltip prop="maxRemainAmount" label="剩余(元)">
						<template slot-scope="scope">
							<span :class="isAddRed(scope.row.maxRemainAmount)">{{ scope.row.maxRemainAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column width="120" show-overflow-tooltip prop="maxRemainUse" label="剩余(度/吨)">
						<template slot-scope="scope">
							<span :class="isAddRed(scope.row.maxRemainUse)">{{ scope.row.maxRemainUse }}</span>
						</template>
					</el-table-column>
					<el-table-column width="180" prop="maxDate" label="采集时间"></el-table-column>
				</el-table-column>
				<el-table-column label="当期" align="center">
					<el-table-column label="累计使用" align="center">
						<el-table-column width="120" show-overflow-tooltip prop="diffTotalUse" label="用量(度/吨)"></el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="diffTotalAmount" label="金额(元)"></el-table-column>
					</el-table-column>
					<el-table-column width="120" show-overflow-tooltip prop="diffPayAmount" label="当期充值(元)"></el-table-column>
				</el-table-column>
			</el-table>
			<simple-pagination @search="doSearch" />
		</el-card>
	</el-card>
</template>
<script>
import "@/assets/scss/common.scss";
import { meterType } from "@/dict/meterDict";
import mixin from "@/mixin/index";
import moment from "moment";
import { pick, assign } from "lodash";
import { get } from "@/assets/common/request";
import LeftFloorTree from "@/components/LeftFloorTree.vue";
export default {
	name: "MeterUseDataIndex",
	mixins: [mixin],
	components: { LeftFloorTree },
	data() {
		return {
			meterType,
			queryListUrl: "/meter/web/snapshot/listPageMeterUseDataSum",
			loadingOverviewData: false,
			overviewData: [
				{
					title: "用量（度/吨）",
					min: 0,
					max: 0,
					diff: 0,
				},
				{
					title: "用额（元）",
					min: 0,
					max: 0,
					diff: 0,
				},
				{
					title: "充值（元）",
					min: 0,
					max: 0,
					diff: 0,
				},
			],
		};
	},
	methods: {
		doSearch() {
			this.getList();
			this.loadSummary();
		},
		doExport() {
			const title = "仪表详情数据";
			const url = "meter/web/detail/export";
			this._export(title, url);
		},
		selectNode(data) {
			this.query = assign(this.query, data);
			this.doSearch();
		},
		loadSummary() {
			this.loadingOverviewData = true;
			const url = "/meter/web/snapshot/meterUseDataSumSummary";
			const searchParams = this.getSearchParams();
			get(url, searchParams)
				.then((data) => {
					const summary = data.data;
					if (summary) {
						this.overviewData[0].min = summary.minSumTotalUse;
						this.overviewData[0].max = summary.maxSumTotalUse;
						this.overviewData[0].diff = summary.diffSumTotalUse;

						this.overviewData[1].min = summary.minSumTotalAmount;
						this.overviewData[1].max = summary.maxSumTotalAmount;
						this.overviewData[1].diff = summary.diffSumTotalAmount;

						this.overviewData[2].min = summary.minSumPayAmount;
						this.overviewData[2].max = summary.maxSumPayAmount;
						this.overviewData[2].diff = summary.diffSumPayAmount;
					}
					this.loadingOverviewData = false;
				})
				.finally(() => {
					this.loadingOverviewData = false;
				});
		},
		isAddRed(val) {
			return val < 0 ? "red" : "";
		},
	},
	computed: {
		monthStart() {
			if (this.query.dataRange && this.query.dataRange.length > 0) {
				return moment(this.query.dataRange[0]).format("YYYY-MM-DD");
			} else {
				return moment()
					.startOf("month")
					.format("YYYY-MM-DD");
			}
		},
		monthEnd() {
			if (this.query.dataRange && this.query.dataRange.length > 1) {
				return moment(this.query.dataRange[1]).format("YYYY-MM-DD");
			} else {
				return moment()
					.endOf("month")
					.format("YYYY-MM-DD");
			}
		},
	},
	mounted() {
		if (!this.query.dataRange) {
			this.query = assign({}, this.query, {
				dataRange: [this.monthStart, this.monthEnd],
			});
		}
		this.doSearch();
	},
};
</script>
<style scoped>
.red {
	color: red;
}
</style>
